import Vue from 'vue'
import Header from '@/module/layout/header/Header.vue'
import BasicsConfigMain from "@/module/cnetong/client/basics/BasicsConfigMain";

let contextPath = process.env.NODE_ENV === 'production' ? '' : '/api'

let config = {
    title: '数据交换传输终端',
    logo: './img/logo.png',
    companyInfo: '技术支持:东方物通科技（北京）有限公司',
    loginToken: 'cnetong_ase_client_online_frontend',
    embedHeader: Vue.component('Header', Header),
    embedHome: Vue.component('BasicsConfigMain', BasicsConfigMain),
    isSinglePage: true,
    ajaxUrl: contextPath,

    changeLangVisible: false,
    isSso: true
}

export default config
